import React, { Component } from 'react';
import classNames from 'classnames';
import 'styles/About.css';
var ga = window.ga;

class AboutPageOne extends Component {
	constructor(props) {
		super(props);

	}

  componentDidMount() {
    ga('send', 'event', 'About 1 Page', 'Page View');
  }

  handlePrev = () => {
    window.dispatchEvent(this.props.events.animPage1, false);
  }

  handleNext = () => {
    // window.dispatchEvent(this.props.events.animPage2, false);
    this.props.hideReact(2);
  }


  render() {
    return (
      <div id="AboutPageOne"  className="about-page" ref={(el) => this.el = el}>
      	
        <h1 className="stagger-in">We partner with agencies to create <span>websites</span>, <span>games</span>, <span>apps</span> and <span>more</span>.</h1>
        <div className="red-line stagger-in"/>
          <p className="stagger-in">Your team handles the creative direction. We bring the concept to life with industry-leading craftsmanship.</p>

        <p></p>
        <div className="arrow-container stagger-in">
          {/*<div className="arrow left" onClick={this.handlePrev}/>*/}
          <div className="arrow right" onClick={this.handleNext}/>
        </div>
      </div>
    );
  }
}

export default AboutPageOne;


// WEBPACK FOOTER //
// ./src/scripts/containers/AboutPageOne.js